import React from 'react';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function CaptialAmounts(props) {
    return (<>
        <h4>Capital Amounts</h4>
        <ResultValue label="C-FSP" value={formatStringAsCurrency(props.result.capFSP)} />
        <ResultValue label="C-Outlier" value={formatStringAsCurrency(props.result.capOutlier)} />
        <ResultValue label="C-IME" value={formatStringAsCurrency(props.result.capIME)} />
        <ResultValue label="C-DSH" value={formatStringAsCurrency(props.result.capDSH)} />
    </>);
}